module.exports = __webpack_public_path__ + "img/avatar2.889087a6.png";